export default function proxyRouter(ctx, proxy) {
  if (!ctx || !ctx.router) {
    return;
  }
  const { router } = ctx;
  Object.keys(router).forEach((key) => {
    if (router.hasOwnProperty(key)) {
      proxy[key] = router[key];
    }
  });
  Object.defineProperties(proxy, {
    query: {
      get() {
        return router && router.getQuery();
      },
    },
    routerBaseName: {
      get() {
        return ctx.getRouterBaseName && ctx.getRouterBaseName();
      },
    },
    slug: {
      get() {
        return router && router.getSlug();
      },
      // set slug to replace
      set(value) {
        if (router) {
          router.push(value);
        }
        return true;
      },
    },
  });
}
